<template>
<nav
    v-if="items"
    :class="$style.breadcrumb"
    :aria-label="$t('breadcrumb')">
    <ol>
        <li
            v-for="({ to, exact, text }, index) in items"
            :key="`breadcrumb-item-${index}`">
            <svg-icon
                v-if="index > 0"
                name="ic_arrow_next" />
            <router-link
                :exact="exact"
                :to="to">
                {{ text }}
            </router-link>
        </li>
    </ol>
</nav>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import {
    HOME,
    GUIDE,
    DEVELOPER_REGISTER,
    DEVELOPER_PROJECTS
} from "@/router/path";
import guideMixin from "@/components/guide.mixin";
import { mapGetters } from "vuex";

export default {
    components: { SvgIcon },
    mixins: [guideMixin],
    computed: {
        ...mapGetters(["projectName", "projectId", "appName", "appId"]),
        projectTab() {
            return this.$route.params?.tab;
        },
        items() {
            const {
                $route: {
                    name: routeName,
                    path,
                    params: { name }
                }
            } = this;
            if (!path || !routeName) return [];

            const $page = this.$t("page");
            const $projectTabs = this.$t("project.tabs");
            const home = { to: HOME, exact: true, text: $page.home };
            switch (routeName) {
            case "home":
                return [home];
            case "guide": {
                const links = [
                    home,
                    { to: GUIDE, exact: true, text: $page.guide }
                ];
                if (name) {
                    const { title } = this.order.find(
                        ({ path }) => path === name
                    );
                    links.push({ to: `${GUIDE}/${name}`, text: title });
                }
                return links;
            }
            case "developerRegister":
                return [
                    home,
                    {
                        to: DEVELOPER_REGISTER,
                        text: $page.developerRegister
                    }
                ];
            case "projects":
            case "projectRegister":
                return [
                    home,
                    { to: DEVELOPER_PROJECTS, text: $page.project }
                ];
            case "projectDetail":
                return [
                    home,
                    { to: DEVELOPER_PROJECTS, text: $page.project },
                    {
                        to: `${DEVELOPER_PROJECTS}/${this.projectId}`,
                        text: this.projectName
                    },
                    {
                        to: `${DEVELOPER_PROJECTS}/${this.projectId}/${this.projectTab}`,
                        text: $projectTabs[this.projectTab]
                    }
                ];
            case "appDetail":
                return [
                    home,
                    { to: DEVELOPER_PROJECTS, text: $page.project },
                    {
                        to: `${DEVELOPER_PROJECTS}/${this.projectId}`,
                        text: this.projectName
                    },
                    {
                        to: `${DEVELOPER_PROJECTS}/${this.projectId}/apps`,
                        text: $page.apps
                    },
                    {
                        to: `${DEVELOPER_PROJECTS}/${this.projectId}/apps/${this.appId}`,
                        text: this.appName
                    }
                ];
            case "appRegister":
                return [
                    home,
                    { to: DEVELOPER_PROJECTS, text: $page.project },
                    {
                        to: `${DEVELOPER_PROJECTS}/${this.projectId}`,
                        text: this.projectName
                    },
                    {
                        to: `${DEVELOPER_PROJECTS}/${this.projectId}/apps`,
                        text: $page.apps
                    },
                    {
                        to: `${DEVELOPER_PROJECTS}/${this.projectId}/apps/new`,
                        text: $page.appRegister
                    }
                ];
            case "welcome":
                return null;
            default: {
                const [subpath] = /^\/[^/]+/.exec(path);
                return [home, { to: subpath, text: $page[routeName] }];
            }
            }
        }
    },
    watch: {
        items: {
            immediate: true,
            handler(value) {
                if (!value || !value.length) return;
                const { text } = value[value.length - 1];
                document.title = `${text ? `${text} - ` : ""}${this.$t(
                    "app.name"
                )}`;
            }
        }
    }
};
</script>

<style lang="scss" module>
@use "@material/typography/typography";
@use "@/assets/scss/variables" as v;
@use "@/assets/scss/mixins" as m;

.breadcrumb {
    display: flex;
    align-items: center;
    height: 54px;
    width: 100%;
    padding: 0px 30px;
    background-color: white;
    border-bottom: 1px solid #e4e7eb;
    font-size: typography.px-to-rem(14px);
    @include m.m_inner;
    ol {
        display: flex;
        align-items: center;
        padding: 0;
        li {
            display: inline-flex;
            align-items: center;
            a {
                color: #777777;
                text-decoration: none;
                font-size: typography.px-to-rem(14px);
                &:hover {
                    color: #000;
                }
            }
            svg {
                color: #cacaca;
                margin: 0 7px;
                width: 7px;
                height: 11px;
            }
            &:last-child {
                a {
                    color: #000;
                }
            }
        }
    }
}
</style>
